/**
 * @name debounce
 *
 * @description Debounce a function by a given time in milliseconds
 *
 * @example
 * import { debounce } from '@workbench/core';
 *
 * const debouncedFn = debounce(fn, 300);
 */
const debounce = (fn, milliseconds) => {
  let scheduled = null;
  return (...args) => {
    clearTimeout(scheduled);
    scheduled = setTimeout(fn, milliseconds, ...args);
  };
};

export { debounce as d };
